import { LoginDetails } from "@/pages/Settings/AccountSettings/LoginDetails";
import { InterfacePreferences } from "@/pages/Settings/AccountSettings/InterfacePreferences";
import { t } from "i18next";

export default function AccountTab(): JSX.Element {
  return (
    <section className="space-y-4">
      <div className="space-y-2">
        <div className="text-xl font-medium">{t("settings.title")}</div>
        <div className="border border-solid border-gray-200 p-4 rounded-md">
          <LoginDetails />
        </div>
      </div>
      <div className="space-y-2">
        <div className="text-xl font-medium">
          {t("settings.account.interfacePreferences.title")}
        </div>
        <div className="border border-solid border-gray-200 p-4 rounded-md">
          <InterfacePreferences />
        </div>
      </div>
    </section>
  );
}
